export default {"src":"/_next/static/media/pi_day_gif.37e2997c.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};